module.exports = __webpack_public_path__ + "img/info-circle.e1d49bd3.svg";